import {pipeHandlers} from 'utils/reduxEffects';
import common from './common/handler';
import timeEntries from './TimeEntriesPage/handler';
import salesmanVisits from './SalesmanVisitsPage/handler';
import calendarPage from './calendarPage/handler';

export default pipeHandlers(common, timeEntries, salesmanVisits, calendarPage);
